export const TOUR_CONSTS = {
    SWITCH_OPEN_STEPS_LIST: 'SWITCH_OPEN_STEPS_LIST',
    SWITCH_OPEN_PROFILE_POPUP: 'SWITCH_OPEN_PROFILE_POPUP',
    UPDATE_ACTIVE_STEP: 'UPDATE_ACTIVE_STEP',
};
